import Vue from 'vue'
export class NoTrace {
    static captcha = null
    static captchaEl = null
    static buttonEl = null
    static success = null
    static fail = null
    static inited = false
    static init ( {elementId="captcha-element", buttonId="captcha-button" } = {}) {
        if (NoTrace.inited) return
        document.getElementsByTagName('head')[0].appendChild(document.createElement('script')).src = 'https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js'
        // 1.在引入阿里云验证码JS脚本的位置之前，或者在html的head标签最前的位置添加一个script脚本，里面保存一个含有region和prefix参数的全局变量AliyunCaptchaConfig即可
        window.AliyunCaptchaConfig = {
            // 必填，验证码示例所属地区，支持中国内地（cn）、新加坡（sgp）
            region: "cn",
            // 必填，身份标。开通阿里云验证码2.0后，您可以在控制台概览页面的实例基本信息卡片区域，获取身份标
            prefix: process.env.VUE_APP_PREFIX,
        };
        // 创建element元素
        NoTrace.captchaEl = document.createElement('div')
        NoTrace.captchaEl.style = 'display: none'
        NoTrace.captchaEl.id = elementId
        document.body.appendChild(NoTrace.captchaEl)
        // 创建button元素
        NoTrace.buttonEl = document.createElement('div')
        NoTrace.buttonEl.style = 'display: none'
        NoTrace.buttonEl.id = buttonId
        document.body.appendChild(NoTrace.buttonEl)
        NoTrace.inited = true
    }
    static getInstance (instance) {
        NoTrace.captcha = instance;
    }
    static start ({ success, fail } = {}) {
        let elementId = NoTrace.captchaEl.id
        let buttonId = NoTrace.buttonEl.id
        window.initAliyunCaptcha({
            SceneId: process.env.VUE_APP_SCENEID, // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
            mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
            element: '#' + elementId, // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
            button: '#' + buttonId, // 触发验证码弹窗的元素。
            success: NoTrace._success,
            fail: NoTrace._fail,
            getInstance: NoTrace.getInstance, // 绑定验证码实例函数，无需修改
            slideStyle: {
                width: 320,
                height: 40,
            }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
            language: 'cn', // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
            onError: function (error) {
                console.log(6)
                Vue.prototype.$TsaEnvironmentCheck.hide()
                NoTrace.fail && NoTrace.fail(error);
                console.error('onError=' + error);
            },
            onClose: function error(error) {
                console.log(7)
                Vue.prototype.$TsaEnvironmentCheck.hide()
                console.error('onClose=' + error);
            }
        })
        NoTrace.success = success;
        NoTrace.fail = fail;
        Vue.prototype.$TsaEnvironmentCheck.show({
            message: '智能验证检测中'
        })
        // console.log(NoTrace.buttonEl)
        console.log(1)
       setTimeout(() => {
        console.log(2)
            NoTrace.buttonEl.click()
            console.log(3)
       }, 1000);
        
    }
    static async _success (captchaVerifyParam) {
        // 入参为验签captchaVerifyParam
        // 1.向后端发起业务请求进行验证码验签captchaVerifyParam校验
        // 2.根据校验结果来进行业务处理
        // 3.如业务需要重新进行验证码验证，调用验证码初始化方法initAliyunCaptcha重新初始化验证码
        // console.log(captchaVerifyParam);
        console.log(4)
        NoTrace.success && NoTrace.success(captchaVerifyParam);
        Vue.prototype.$TsaEnvironmentCheck.hide()
    }
    // 验证码验证失败回调函数，透出验证失败错误码。
    static _fail (error) {
        console.log(5)
        Vue.prototype.$TsaEnvironmentCheck.hide()
        console.error(error);
        NoTrace.fail && NoTrace.fail(error);
    }
}
export default NoTrace


// WEBPACK FOOTER //
// ./src/js/noTrace.js